module.exports = __webpack_public_path__ + "static/media/Deluxe.0b72a3f8.jpg";